import React from 'react';
import { LargeLabelCell, SmallLabelCell } from 'base/components/table/Cells';
import ProfilePicture from 'base/components/ProfilePicture';
import UnstyledList from 'base/components/UnstyledList';
import SmallLabel from 'base/components/SmallLabel';
import { DeskPhoneIcon, EmailIcon, FaxIcon, PhoneIcon, SmartphoneIcon } from 'base/components/Icon';
import { useAppSelector } from 'store/hooks';
import { getAccessToken } from 'auth';

export const ProfilePictureCell = (
  { row, original }, // eslint-disable-line
) => {
  const token = useAppSelector(getAccessToken);
  return (
    <div>
      <ProfilePicture token={token} contactId={original.id} mediaId={original?.image?.id} size="medium" />
    </div>
  );
};

export const ContactInfoCell = (
  { row, original }, // eslint-disable-line
) => (
  <div>
    <UnstyledList>
      {original.email && (
        <li>
          <SmallLabel>
            <EmailIcon /> <a href={`mailto:${original.email}`}>Email</a>
          </SmallLabel>
        </li>
      )}

      {original.phone && (
        <li>
          <SmallLabel>
            <PhoneIcon /> <a href={`tel:${original.phone}`}>{original.phone}</a>
          </SmallLabel>
        </li>
      )}

      {original.mobile && (
        <li>
          <SmallLabel>
            <SmartphoneIcon /> <a href={`tel:${original.mobile}`}>{original.mobile}</a>
          </SmallLabel>
        </li>
      )}

      {original.fax && (
        <li>
          <SmallLabel>
            <FaxIcon /> <a href={`tel:${original.fax}`}>{original.fax}</a>
          </SmallLabel>
        </li>
      )}

      {original.switchboard && (
        <li>
          <SmallLabel>
            <DeskPhoneIcon /> <a href={`tel:${original.switchboard}`}>{original.switchboard}</a>
          </SmallLabel>
        </li>
      )}
    </UnstyledList>
  </div>
);

export const UserCell = (
  { row, original }, // eslint-disable-line
) => <SmallLabel>{original.user ? 'Yes' : 'No'}</SmallLabel>;

export const ProfilePictureColumn = {
  Cell: ProfilePictureCell,
  Header: ' ',
  width: 83,
  showOnMobile: true,
  filterable: false,
  sortable: false,
};
export const SalutationColumn = {
  Header: ' ',
  accessor: 'salutation',
  Cell: SmallLabelCell('salutation'),
  width: 50,
  showOnMobile: false,
};
export const LastNameColumn = {
  Header: 'Name',
  accessor: 'lastName',
  Cell: LargeLabelCell('lastName'),
  showOnMobile: true,
};
export const FirstNameColumn = {
  Header: 'First name',
  accessor: 'firstName',
  Cell: LargeLabelCell('firstName'),
  showOnMobile: true,
};
export const ContactInfoColumn = {
  Header: 'Contact',
  id: 'contactinfo',
  accessor: row => `${row.email} ${row.phone} ${row.mobile} ${row.fax} ${row.switchboard}`,
  Cell: ContactInfoCell,
  showOnMobile: true,
};
export const PositionColumn = {
  Header: 'Function',
  accessor: 'position',
  Cell: SmallLabelCell('position'),
  showOnMobile: false,
};
export const DivisionColumn = {
  Header: 'Division',
  accessor: 'division',
  Cell: SmallLabelCell('division'),
  showOnMobile: false,
};
